import { MAX_NUMBER_OF_RESULTS, PAGE_SIZE_OPTIONS } from '@lib/constants/coveo';

/**
 * Parse a URL-supplied `numberOfResults`: any positive integer, clamped to
 * MAX_NUMBER_OF_RESULTS (like `firstResult` is clamped to MAX_FIRST_RESULT),
 * so a crafted large value degrades to the biggest allowed page. Shared by
 * both search arms so they accept and reject the same inputs.
 */
export function parseUrlPageSize(
  value: string | null | undefined
): number | undefined {
  const pageSize = Number(value);
  if (!Number.isInteger(pageSize) || pageSize <= 0) {
    return undefined;
  }
  return Math.min(pageSize, MAX_NUMBER_OF_RESULTS);
}

/**
 * Guard for every persisted or remotely configured page size (localStorage,
 * cookie, flag payload): only the dropdown options qualify, so a one-off URL
 * size never becomes a saved preference.
 */
export function isPageSizeOption(value: number): boolean {
  return PAGE_SIZE_OPTIONS.includes(value);
}

/**
 * The page sizes a results-per-page control offers: the standard options,
 * plus `current` in sorted position when it is a valid custom URL size, so the
 * control always shows the size the grid is actually rendering.
 */
export function getPageSizeOptions(current: number): number[] {
  if (
    isPageSizeOption(current) ||
    parseUrlPageSize(String(current)) !== current
  ) {
    return [...PAGE_SIZE_OPTIONS];
  }
  return [...PAGE_SIZE_OPTIONS, current].sort((a, b) => a - b);
}
